import { hasPermission } from '../config/roleConfig'
import { useCurrentUserRole } from '../hooks/useCurrentUserRole'

const RoleGuard = ({ children, fallback = null, permission }) => {
  const role = useCurrentUserRole()

  return hasPermission(role, permission) ? children : fallback
}

export default RoleGuard
